import type { FC } from "react"
import classNames from "classnames"
import Link from "~/components/Link"
import type { WithLinkFragment } from "~/contentful"
import ResponsiveContentfulImage from "~/components/ResponsiveContentfulImage"

interface Props {
  link: WithLinkFragment & { blurb?: string | null }
  width?: number
  height?: number
  mobileWidth?: number
  mobileHeight?: number
  className?: string
}

const Banner: FC<Props> = ({
  link,
  width,
  height,
  mobileWidth,
  mobileHeight,
  className
}) => {
  if (!link.url) return null
  if (!link.image?.url) return null

  return (
    <Link to={link.url} className={classNames("block", className)}>
      <ResponsiveContentfulImage
        src={link.image.url}
        width={width}
        height={height}
        className="hidden sm:block"
        alt={link.blurb ?? ""}
        lazyLoad={false}
      />

      {link.mobileImage?.url && (
        <ResponsiveContentfulImage
          src={link.mobileImage.url}
          width={mobileWidth}
          height={mobileHeight}
          className="sm:hidden"
          alt={link.blurb ?? ""}
          lazyLoad={false}
        />
      )}
    </Link>
  )
}

export default Banner
